// modalStack.js
let modalStack = [];

export function pushModal(modalRef) {
  modalStack.push(modalRef);
}

export function popModal() {
  modalStack.pop();
}

export function isTopModal(modalRef) {
  return modalStack[modalStack.length - 1] === modalRef;
}

export function getModalStack() {
  return modalStack;
}
